import React from "react";
import BaseModal from "../BaseModal";
import { Button } from "../../ui/button";
import { RotateCcw } from "lucide-react";

function GameLostModal({ open, onPlayAgain }) {

  return (
    <BaseModal
      title="You lost."
      initiallyOpen={open}
      footerElements={
        <Button
          variant="secondary"
          onClick={onPlayAgain}
          className="w-full"
        >
          <RotateCcw className="h-4 w-4 mr-2" strokeWidth={1} />
          Play Again
        </Button>
      }
      showActionButton={false}
    >
      <div className="grid gap-y-2">
        <p className="text-base font-medium text-center">
          Better luck next time!
        </p>
      </div>
    </BaseModal>
  );
}

export default GameLostModal;
